import { TextField, TextFieldProps } from '@mui/material';
import { Control, Controller, FieldPath, FieldValues } from 'react-hook-form';

export interface TextAreaProps<TFieldValues extends FieldValues = FieldValues> {
  name: FieldPath<TFieldValues>;
  control: Control<TFieldValues>;
  label?: string;
  disabled?: boolean;
  required?: boolean;
  helperText?: string;
  placeholder?: string;
  rows?: number;
  minRows?: number;
  maxRows?: number;
}

export function TextArea<TFieldValues extends FieldValues = FieldValues>({
  name,
  control,
  label,
  disabled,
  required,
  helperText,
  placeholder,
  rows = 4,
  minRows,
  maxRows,
  ...textFieldProps
}: TextAreaProps<TFieldValues> & Omit<TextFieldProps, 'name' | 'control' | 'error' | 'helperText' | 'multiline' | 'rows' | 'minRows' | 'maxRows'>) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <TextField
          {...field}
          {...textFieldProps}
          fullWidth
          multiline
          label={label}
          placeholder={placeholder}
          disabled={disabled}
          required={required}
          error={!!fieldState.error}
          helperText={fieldState.error?.message || helperText}
          rows={rows}
          minRows={minRows}
          maxRows={maxRows}
        />
      )}
    />
  );
}